import { DashboardMenu } from "../../data/menu";
import BreadCrump from "../tools/breadcrump";
import DashboardButton from "../Setting/dashboardButton";
import { useTranslation } from 'react-i18next';

export default function IndexRealEstate() {
    const { t } = useTranslation();

    const breadcrump = [
        { name: t('Dashboard'), url: '/dashboard' },
        { name: t('Real Estate System'), url: null },
    ];
    return (
        <>
            <div className="text-left  bg-white  p-3 m-4 directions  h-[100vh] mb-5 ">
                <BreadCrump data={breadcrump}></BreadCrump>
                <DashboardButton item="Real Estate System" DashboardMenu={DashboardMenu}></DashboardButton>
            </div>
        </>
    );
}
